import MaterialList from "../app/web/materials/materials/list/material-list.jsx";
import MaterialForm from "../app/web/materials/materials/form/material-form.jsx";
import MaterialGroupList from "../app/web/materials/groups/list/material-group-list.jsx";
import MaterialGroupForm from "../app/web/materials/groups/form/material-group-form.jsx";
import MaterialKitList from "../app/web/materials/kits/list/material-kit-list.jsx";
import MaterialKitForm from "../app/web/materials/kits/form/material-kit-form.jsx";
import MaterialStorageList from "../app/web/materials/storage/list/material-storage-list.jsx";
import MaterialStorageForm from "../app/web/materials/storage/form/material-storage-form.jsx";
import MaterialAlertsList from "../app/web/materials/alerts/list/material-alerts-list.jsx";
import MaterialAlertsForm from "../app/web/materials/alerts/form/material-alerts-form.jsx";
import MaterialSuppliersList from "../app/web/materials/suppliers/list/material-suppliers-list.jsx";
import MaterialSuppliersForm from "../app/web/materials/suppliers/form/material-suppliers-form.jsx";
import MaterialXStorageList from "../app/web/materials/material-x-storage/list/material-x-storage-list.jsx";
import MaterialTransferList from "../app/web/materials/transfers/list/material-transfer-list.jsx";
import MaterialTransferForm from "../app/web/materials/transfers/form/material-transfer-form.jsx";
import MaterialRegistersList from "../app/web/materials/registers/list/material-registers-list.jsx";
import MaterialRegistersForm from "../app/web/materials/registers/form/material-registers-form.jsx";
import MaterialMaintenancesList from "../app/web/materials/maintenances/list/material-maintenances-list.jsx";
import MaterialMaintenancesForm from "../app/web/materials/maintenances/form/material-maintenances-form.jsx";
import MaterialDecreasesList from "../app/web/materials/decreases/list/material-decreases-list.jsx";
import MaterialDecreasesForm from "../app/web/materials/decreases/form/material-decreases-form.jsx";
import MaterialCautionsList from "../app/web/materials/cautions/list/material-cautions-list.jsx";
import MaterialMovementsInit from "../app/web/materials/movements/material-movements-init.jsx";
import MaterialsHome from "../app/web/materials/home/materials-home.jsx";
import {protectedLoader, requirePermission} from "./middleware.js";
import {PermissionEnum} from "../utils/enums/permission-enum.js";

const MANAGE = requirePermission(PermissionEnum.ERP_MATERIALS_MANAGE);
const MANAGE2 = requirePermission(PermissionEnum.ERP_MATERIALS_MANAGE2);
const RESPONSIBLE = requirePermission(PermissionEnum.ERP_MATERIALS_RESPONSIBLE);
const ANY_MATERIALS = requirePermission([
    PermissionEnum.ERP_MATERIALS_RESPONSIBLE,
    PermissionEnum.ERP_MATERIALS_MANAGE,
    PermissionEnum.ERP_MATERIALS_MANAGE2,
]);

const RouterMaterials = () => [
    {
        id: "material",
        path: "",
        Component: MaterialList,
        loader: MANAGE
    },
    {
        id: "material-form",
        path: "form/:id?",
        Component: MaterialForm,
        loader: MANAGE
    },
    {
        id: "material-groups",
        path: "groups",
        Component: MaterialGroupList,
        loader: MANAGE
    },
    {
        id: "material-groups-form",
        path: "groups/form/:id?",
        Component: MaterialGroupForm,
        loader: MANAGE
    },
    {
        id: "material-kit",
        path: "kits",
        Component: MaterialKitList,
        loader: MANAGE
    },
    {
        id: "material-kit-form",
        path: "kits/form/:id?",
        Component: MaterialKitForm,
        loader: MANAGE
    },
    {
        id: "material-storage",
        path: "storages",
        Component: MaterialStorageList,
        loader: MANAGE
    },
    {
        id: "material-storage-form",
        path: "storages/form/:id?",
        Component: MaterialStorageForm,
        loader: MANAGE
    },
    {
        id: "material-alerts",
        path: "alerts",
        Component: MaterialAlertsList,
        loader: MANAGE
    },
    {
        id: "material-alerts-form",
        path: "alerts/form/:id?",
        Component: MaterialAlertsForm,
        loader: MANAGE
    },
    {
        id: "material-suppliers",
        path: "suppliers",
        Component: MaterialSuppliersList,
        loader: protectedLoader
    },
    {
        id: "material-suppliers-form",
        path: "suppliers/form/:id?",
        Component: MaterialSuppliersForm,
        loader: protectedLoader
    },
    {
        id: "material-x-storage-list",
        path: "material-x-storage",
        Component: MaterialXStorageList,
        loader: RESPONSIBLE
    },
    {
        id: "material-transfers",
        path: "transfers",
        Component: MaterialTransferList,
        loader: MANAGE2
    },
    {
        id: "material-transfers-form",
        path: "transfers/form/:id?",
        Component: MaterialTransferForm,
        loader: MANAGE2
    },
    {
        id: "material-registers",
        path: "registers",
        Component: MaterialRegistersList,
        loader: MANAGE2
    },
    {
        id: "material-registers-form",
        path: "registers/form/:id?",
        Component: MaterialRegistersForm,
        loader: MANAGE2
    },
    {
        id: "material-maintenances",
        path: "maintenances",
        Component: MaterialMaintenancesList,
        loader: MANAGE2
    },
    {
        id: "material-maintenances-form",
        path: "maintenances/form/:id?",
        Component: MaterialMaintenancesForm,
        loader: MANAGE2
    },
    {
        id: "material-decreases",
        path: "decreases",
        Component: MaterialDecreasesList,
        loader: MANAGE2
    },
    {
        id: "material-decreases-form",
        path: "decreases/form/:id?",
        Component: MaterialDecreasesForm,
        loader: MANAGE2
    },
    {
        id: "material-cautions",
        path: "cautions",
        Component: MaterialCautionsList,
        loader: RESPONSIBLE
    },
    {
        id: "material-movements",
        path: "movements",
        Component: MaterialMovementsInit,
        loader: RESPONSIBLE
    },
    {
        id: "material-home",
        path: "home",
        Component: MaterialsHome,
        loader: ANY_MATERIALS
    },
];

export default RouterMaterials;
